import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import EmbeddedDemo from './EmbeddedDemo'
import EmbeddedEditorActions from './EmbeddedEditorActions'
import EmbeddedElement from './EmbeddedElement'
import EmbeddedFormValue from './EmbeddedFormValue'
import codeIcon from './assets/embedded.svg'

export default genElementConfig(CONFIG_ELEMENTS.embedded, {
  label: t('elements.embedded.label'),
  icon: codeIcon,
  group: ElementGroup.view,
  styleFields: null,
  Element: EmbeddedElement,
  Demo: [EmbeddedDemo],
  FormValue: EmbeddedFormValue,
  FormBrand: null,
  EditorActions: EmbeddedEditorActions,
})
